import script from "./ToolsIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolsIndex.vue?vue&type=script&setup=true&lang=js"

import "./ToolsIndex.vue?vue&type=style&index=0&id=a5ce97bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5ce97bc"]])

export default __exports__